import Index from '@/views/index.vue'
import PermissionDefinition from '@/lib/permission-definition'
export const routers = [
	{
		path: '/',
		name: 'index',
		meta: { title: '首页', allowAnonymous: false },
		component: Index,
	},
	{
		path: '/login',
		name: 'login',
		meta: { title: '用户登录', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
	},
	{
		path: '/auth',
		name: 'auth',
		meta: { title: '授权检查', allowAnonymous: true, isDriver: false },
		component: () => import(/* webpackChunkName: "authenticate" */ '@/views/authenticate.vue'),
	},
	{
		path: '/dispatchManager',
		name: 'DispatchManager',
		meta: { title: '待派工列表', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/dispatched/DispatchManager.vue'),
	},
	{
		path: '/dispatchDetail',
		name: 'DispatchDetail',
		meta: { title: '待派工操作', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/dispatched/DispatchDetail.vue'),
	},
	{
		path: '/statementManager',
		name: 'StatementManager',
		meta: { title: '待结单列表', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/statementing/statementManager.vue'),
	},
	{
		path: '/statementDetail',
		name: 'StatementDetail',
		meta: { title: '待结单操作', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/statementing/statementDetail.vue'),
	},
	{
		path: '/dispatchChange',
		name: 'DispatchChange',
		meta: { title: '转派', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/statementing/dispatchChange.vue'),
	},
	{
		path: '/statementedManager',
		name: 'StatementedManager',
		meta: { title: '已结单列表', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/statemented/statementedManager.vue'),
	},
	{
		path: '/returnVisit',
		name: 'ReturnVisit',
		meta: { title: '回访', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/statemented/returnVisit.vue'),
	},
	{
		path: '/returnVisitedManager',
		name: 'ReturnVisitedManager',
		meta: { title: '回访列表', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/returnVisited/returnVisitedManager.vue'),
	},
	{
		path: '/blackListManager',
		name: 'BlackListManager',
		meta: { title: '黑名单列表', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/blackList/blackListManager.vue'),
	},
	{
		path: '/blackListDetail',
		name: 'BlackListDetail',
		meta: { title: '新增黑名单', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/blackList/blackListDetail.vue'),
	},
	{
		path: '/partsRecordManager',
		name: 'PartsRecordManager',
		meta: { title: '产品消耗', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/partsRecord/partsRecordManager.vue'),
	},
	{
		path: '/uploadPhoto',
		name: 'UploadPhoto',
		meta: { title: '上传图片', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/returnVisited/uploadPhoto.vue'),
	},
	{
		path: '/previewPhoto',
		name: 'PreviewPhoto',
		meta: { title: '预览图片', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/returnVisited/previewPhoto.vue'),
	},
	{
		path: '/maintainrecordhistory',
		name: 'MaintainRecordHistory',
		meta: { title: '历史记录', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/statementing/maintainrecordhistory.vue'),
	},
	{
		path: '/schoolManager',
		name: 'SchoolManager',
		meta: { title: '驾校列表', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/business/SchoolManager.vue'),
	},
	{
		path: '/teacherManager',
		name: 'TeacherManager',
		meta: { title: '教练列表', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/business/TeacherManager.vue'),
	},
	{
		path: '/carListManager',
		name: 'CarListManager',
		meta: { title: '车辆列表', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/business/CarListManager.vue'),
	},
	{
		path: '/studentPhotoManager',
		name: 'StudentPhotoManager',
		meta: { title: '学员照片', allowAnonymous: true },
		component: () => import(/* webpackChunkName: "login" */ '@/views/maintain/business/StudentPhotoManager.vue'),
	},
]
